import { accountStatus } from '@models/api/user/profile/profile';
import {
    BaseIcon,
    BookIcon,
    InfoOutlineIcon,
    InvestIcon,
} from '@moreharvest/component-library';
import { AnalyticsDestination, AnalyticsLinkId } from 'mh-client';

type NavLinkAnalytics =
    | { event: 'nav'; destination: string }
    | { event: 'link'; linkId: string; destination: string };

interface NavBarLinks {
    label: string;
    url: string;
    icon: JSX.Element;
    accountStatus: accountStatus[];
    analytics: NavLinkAnalytics;
}

export const links: NavBarLinks[] = [
    {
        label: 'screen_invest_now',
        url: '/funds/MHJP',
        icon: (
            <BaseIcon size="regular">
                <InvestIcon className="stroke-neutral-800 dark:stroke-neutral-800-dark" />
            </BaseIcon>
        ),
        accountStatus: ['Complete'],
        analytics: {
            event: 'nav',
            destination: AnalyticsDestination.getInstance().INVEST_NOW,
        },
    },
    {
        label: 'screen_blog',
        url: 'https://blog.moreharvest.com/en',
        icon: (
            <BaseIcon size="regular">
                <BookIcon className="fill-neutral-800 dark:fill-neutral-800-dark" />
            </BaseIcon>
        ),
        accountStatus: [
            'None',
            'Pending',
            'KycDeclined',
            'KycVerified',
            'Complete',
        ],
        analytics: {
            event: 'link',
            linkId: AnalyticsLinkId.getInstance().BLOG,
            destination: AnalyticsDestination.getInstance().BLOG,
        },
    },
    {
        label: 'screen_support',
        url: '/support',
        icon: (
            <BaseIcon size="regular">
                <InfoOutlineIcon className="fill-neutral-800 dark:fill-neutral-800-dark" />
            </BaseIcon>
        ),
        accountStatus: [
            'None',
            'Pending',
            'KycDeclined',
            'KycVerified',
            'Complete',
        ],
        analytics: {
            event: 'nav',
            destination: AnalyticsDestination.getInstance().SUPPORT,
        },
    },
];
